import { CheckCircle2 } from 'lucide-react';

const whyItems = [
  'First-time cleanings', 'Homes that need extra attention', 'Busy families',
  'Before guests arrive', 'Seasonal refresh', 'Homes not cleaned recently',
  'Preparing for maintenance service'
];

export const WhyChooseCards = () => (
  <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 max-w-3xl mx-auto">
    {whyItems.map((item, i) => (
      <div key={i} className="flex items-center justify-center gap-2 bg-white rounded-lg px-4 py-2.5 border border-gray-100">
        <CheckCircle2 size={16} className="text-[#4CAF50] flex-shrink-0" />
        <span className="text-[#333] text-sm">{item}</span>
      </div>
    ))}
  </div>
);
